module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "prol"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn-1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Selçuk, Turkey, AD March 26, 1982, 1:09 ")]), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("A.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("They laid her down and told her to be still, not to push until they said she could. All she wanted was to be rid of the pain, rid of the thing inside her that felt like it was ripping her tiny body to shreds.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why did they have to choose her? Why couldn’t she have a life like other children?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When the Girl’s screams turned to howling, unbearable and animal-like, the older man, a priest, dropped to his knees, lifted his hands to God, and began praying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("“Shlom lekh bthoolto Mariam. Maliath taibootho moran a’ammekh mbarakhto at bneshey,”")]), _vm._v(" he chanted in Aramaic, tears spilling onto the small sheet that still covered her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Girl howled again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The other man, a soldier, who would soon be the Girl’s husband, looked to the woman in the burqa for approval, then finally laid his hand on her swollen belly and told her, “"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Now,")]), _vm._v(" push! Push!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The promised relief of pushing was almost as unbearable to her not fully formed body as the holding back had been. Would they let her go home when it was finally over?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the baby stopped its kicking. It was still, but the pain was worse. Then it—the boy inside her—moved, propelling itself toward the light.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His head was beginning to crown, so the woman, wearing gloves, carefully and with trembling hands, took surgical scissors and snipped the stretching skin downward to enlarge the vaginal opening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They had told her that was how it would happen, when she first became pregnant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was no other way she could have known these things unless they had explained them to her beforehand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was thirteen. And she was still a virgin.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 78
// module chunks = 0